import { render } from "./ScoreNum.vue?vue&type=template&id=74f11e6f&scoped=true&ts=true"
import script from "./ScoreNum.vue?vue&type=script&lang=ts"
export * from "./ScoreNum.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f11e6f"]])

export default __exports__